import { Formik } from 'formik';
import CustomInputField from '../../../common/CustomInputField';
import { useEffect, useState } from 'react';
import { walletsReportFilter } from '../../../api/login/Login';
const initialValues = { from: "", to: "" }

function WalletsReportsSearch({apes=false, setPage,setSubmitButton ,setInitialValues ,  initialValues, submitForm, page }) {
    // const params = useParams();
    const validate = (values) => {
        let errors = {};
        // if (!values.amount) {
        //     errors.amount = "Amount is required";
        // }
        return errors;
    };


    const onSubmitHandler = (values)=>{
     console.log(values , "onsumit")
     setInitialValues(values)
     setPage(0)
     setSubmitButton((pre)=>!pre)
    //  submitForm(page)
    }

    const handleReset = (resetForm) => {
        console.log('click');
        resetForm();
        setInitialValues({
            order_id: '',
            txn_id: '',
            start_date: '',
            end_date: '',
            type: '',
            trans_type: '',
        }); // Ensuring a new reference
    
        setPage(0);
        setSubmitButton((pre)=>!pre)
    };
    
    
    return (
        <>
            <div className="row m-4">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-responsive active-projects style-1">
                                <div className="tbl-caption tbl-caption-2">
                                    <h4 className="heading mb-0"><b>Wallets Report Search - </b></h4>
                                </div>
                                <Formik
                                //  key={JSON.stringify(initialValues)}
                                    initialValues={initialValues}
                                    validate={validate}
                                    // onSubmit={() => { submitForm(page, initialValues) }}
                                    onSubmit={onSubmitHandler}
                                    // enableReinitialize
                                    enableReinitialize
                                    
                                    className="tbl-captionn"
                                >
                                    {(formik) => {
                                        const {
                                            values,
                                            handleChange,
                                            handleSubmit,
                                            errors,
                                            touched,
                                            handleBlur,
                                            isValid,
                                            dirty,
                                            resetForm
                                        } = formik;
                                        return (
                                            <form className="tbl-captionn" onSubmit={handleSubmit}>
                                                <div className="row">
                                                    {apes === false &&
                                                    <div className="col-xl-4 mb-3">
                                                        <select class="form-select" aria-label="Default select example" name="trans_type" value={values?.trans_type} onChange={handleChange}>
                                                            <option selected value={''}>Select Transaction type</option>
                                                            <option value="refund">Refund</option>
                                                            <option value="Recharge">Recharge</option>
                                                            <option value="transfer">Transfer</option>
                                                            <option value="Order">Order</option>
                                                            <option value="bill_pay">bill_pay</option>
                                                            <option value="pan">pan</option>
                                                            <option value="fastag">fastag</option>
                                                            <option value="credit_card">credit_card</option>
                                                            <option value="lic_bill">lic_bill</option>
                                                            <option value="qr_code">qr_code</option>
                                                            <option value="add-wallet">add-wallet</option>
<option value="onBoarding">onBoarding</option>
<option value="fromAEPS">fromAEPS</option>
<option value="reversal">reversal</option>
<option value="ureversal">ureversal</option>
<option value="ucommission">ucommission</option>
<option value="validate_beneficiary">validate_beneficiary</option>
<option value="dmt">dmt</option>
<option value="dmt_rev">dmt_rev</option>
<option value="admintrf">admintrf</option>
<option value="cms">cms</option>

                                                        </select>
                                                    </div> }
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="date"
                                                            placeholder="From *"
                                                            value={values.start_date}
                                                            hasError={errors.start_date && touched.start_date}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.start_date}
                                                            autoFocus={true}
                                                            id="start_date"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="date"
                                                            placeholder="To *"
                                                            value={values.end_date}
                                                            hasError={errors.end_date && touched.end_date}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.end_date}
                                                            autoFocus={true}
                                                            id="end_date"
                                                        />

                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <select class="form-select" aria-label="Default select example" name="type" value={values?.type} onChange={handleChange}>
                                                            <option selected value={''}> Select type</option>
                                                            <option value="credit">credit</option>
                                                            <option value="debit">debit</option>
                                                        </select>
                                                    </div>

                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="text"
                                                            placeholder="Order ID"
                                                            value={values?.order_id}
                                                            hasError={errors.order_id && touched.order_id}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.order_id}
                                                            autoFocus={true}
                                                            id="order_id"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="text"
                                                            placeholder="Transaction ID"
                                                            value={values.txn_id}
                                                            hasError={errors.txn_id && touched.txn_id}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.txn_id}
                                                            autoFocus={true}
                                                            id="txn_id"
                                                        />
                                                    </div>

                                                    <div className="col-lg-4 col-md-4 mg-t-10 mg-sm-t-25">
                                                        <button
                                                            className="btn btn-primary me-1"
                                                            type="submit"
                                                        // disabled={!isValid || !dirty}
                                                        >
                                                            Search
                                                        </button>
                                                        <button
                                                            className="btn btn-info me-1"
                                                            type="button"
                                                        // disabled={!isValid || !dirty}
                                                            onClick={()=>handleReset(resetForm)}
                                                        >
                                                            Reset
                                                        </button>
                                                        {/* <button className="btn btn-danger pd-x-20 rounded-0" type="button" data-toggle="modal" data-target="#transaction_download_model"><i className="fas fa-download"></i> Download</button> */}
                                                    </div>

                                                </div>
                                            </form>
                                        );
                                    }}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default WalletsReportsSearch